import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";

import { H1, P } from "../../atoms/Texts";
import { useNavigate } from "react-router";
import Breadcrumb from "../Breadcrumb";

const ActionPageHeroStyle = styled.div`
  background: #f8f6fe;
`;

const ActionPageHero = ({
  title,
  description,
  className,
  back,
  goBackText,
  action,
  actionComponent,
  breadcrumb,
  routes,
  pClassName,
}) => {
  const navigate = useNavigate();

  return (
    <ActionPageHeroStyle
      className={`pt-16 pb-12 container ${className ? className : ""}`}
    >
      <div className="flex justify-between">
        <div>
          <H1 fontSize="26px" color="#22202D" className="">
            {title}
          </H1>
          {description && (
            <P className={pClassName} color="#1E202A">
              {description}
            </P>
          )}
          {breadcrumb && <Breadcrumb history={routes} />}
        </div>
        {action && <div>{actionComponent}</div>}
        {back && (
          <div
            className="flex items-center cursor-pointer"
            style={{
              width: "fit-content",
            }}
            onClick={() => navigate(-1)}
          >
            <Icon.ChevronLeft size={14} color="#7D7B96" className="mr-2" />
            <P color="#1E202A" fontSize="14px" smallSize="14px">
              {goBackText}
            </P>
          </div>
        )}
      </div>
    </ActionPageHeroStyle>
  );
};

export default ActionPageHero;
